export const ModuleName = 'basdata';
export const DisplayName = 'Basdata';
